export const faqs = [
  {
    id: 1,
    question: 'How do I book a service?',
    answer: 'You can book directly through our website using the booking form, call us at +1 (718) 555-0147, or send us an email. We recommend booking at least 48 hours in advance for walks and sittings, and one week ahead for training sessions.',
  },
  {
    id: 2,
    question: 'Are your caregivers certified?',
    answer: 'Yes. Every caregiver undergoes a rigorous vetting process including background checks, pet first aid certification, and a 40-hour training program covering behavior reading, urban safety, and emergency protocols.',
  },
  {
    id: 3,
    question: 'What areas do you serve?',
    answer: 'We currently serve Brooklyn, Manhattan, Queens, and the Bronx. We are actively expanding and plan to reach Staten Island by late 2025.',
  },
  {
    id: 4,
    question: 'Can I meet my caregiver before booking?',
    answer: 'Absolutely. We offer complimentary meet-and-greet sessions where you, your pet, and your assigned caregiver can get acquainted. This is especially recommended for sitting and training services.',
  },
  {
    id: 5,
    question: 'What is your cancellation policy?',
    answer: 'Walks and sittings can be cancelled up to 24 hours before the scheduled time for a full refund. Training sessions require 48 hours notice. Cancellations within the notice period are subject to a 50% fee.',
  },
  {
    id: 6,
    question: 'Do you offer emergency services?',
    answer: 'Yes, we have an on-call team for urgent sitting needs and a 24/7 hotline for existing clients. Emergency walks can typically be arranged within 2 hours.',
  },
];

export const contactInfo = {
  address: '1 Birzhova Square, Odesa, Ukraine',
  email: 'hello@pawandco.com',
  phone: '+1 (718) 555-0147',
  hours: 'Mon - Fri: 7:00 AM - 8:00 PM\nSat - Sun: 8:00 AM - 6:00 PM',
};